@let accessStatus = accessService.accessStatus | async;
@let userPlan = accessService.userPlan | async;
@let activeLayer = layerStore.activeLayer | async;
@let activeLevel = layerStore.activeLevel | async;
@let highlightedFeature = guideService.highlightFeature$ | async;
@let highlightPulse = guideService.highlightPulse$ | async;

<!-- The scope the indices are read against. Two radios under a label used to
     say this; the segment says it in one row and reads as what it is - a
     switch, where both sides repaint the map. -->
@if (showScope) {
  <div class="scope" role="radiogroup" aria-label="Compare this area against">
    <button
      type="button"
      role="radio"
      class="scope__option"
      [class.is-on]="selectedScope === FeatureScope.BY_COUNTRY"
      [attr.aria-checked]="selectedScope === FeatureScope.BY_COUNTRY"
      (click)="onScopeClick(FeatureScope.BY_COUNTRY)"
    >
      vs US
    </button>
    <button
      type="button"
      role="radio"
      class="scope__option"
      [class.is-on]="selectedScope === FeatureScope.BY_STATE"
      [attr.aria-checked]="selectedScope === FeatureScope.BY_STATE"
      (click)="onScopeClick(FeatureScope.BY_STATE)"
    >
      vs State
    </button>
  </div>
}

@if (
  disclaimer &&
  (!disclaimer.visibleOnLevels ||
    disclaimer.visibleOnLevels.includes(activeLevel!))
) {
  <p class="note" [attr.data-cy]="'visible-on-levels-disclaimer'">
    {{ disclaimer.text }}
  </p>
}

<div class="rows" role="radiogroup">
  @for (row of rows; track row.feature.featureConst) {
    @let isAccessible =
      row.feature.featureConst | isFeatureAccessible: accessStatus;

    @if (isVisible(row, isAccessible)) {
      @let layer = layerOf(row);
      @let isActive = activeLayer === layer;
      @let levelDisabled = isDisabledOnLevel(row, activeLevel);
      @let isHighlighted = highlightedFeature === row.feature.featureConst;

      <div
        class="row"
        #rowEl
        [class.is-hero]="row.isHero"
        [class.is-active]="isActive"
        [class.is-locked]="!isAccessible"
        [class.is-disabled]="levelDisabled"
        [class.guide-highlight]="isHighlighted"
        [class.guide-highlight-pulse]="isHighlighted && highlightPulse"
        role="radio"
        [attr.aria-checked]="isActive"
        [attr.aria-disabled]="levelDisabled ? true : null"
        [attr.tabindex]="levelDisabled ? -1 : 0"
        [attr.data-cy]="row.feature.e2eName"
        (click)="onRowClick(row, isAccessible, levelDisabled, rowEl)"
        (keydown.enter)="onRowClick(row, isAccessible, levelDisabled, rowEl)"
        (keydown.space)="
          $event.preventDefault();
          onRowClick(row, isAccessible, levelDisabled, rowEl)
        "
      >
        <div class="row__head">
          @if (row.iconPath) {
            <svg
              class="row__glyph"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path [attr.d]="row.iconPath" />
            </svg>
          }

          <span class="row__text">
            <!-- The cursor rides with the name, so the thing to click and the
                 instruction to click it are one phrase. -->
            <span class="row__nameline">
              <span class="row__name">{{
                row.feature.featureConst | LayerNameFormatPipe: userPlan
              }}</span>

              @if (isHighlighted) {
                <svg class="row__cursor" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M9 4 18 12.6l-4.2.3 1.8 4.2-2.2.9-1.8-4.2-3 2.9z"
                    fill="currentColor"
                  />
                  <path
                    d="M6.6 3.2 5.1 1.7M4.2 5.6 2.1 5.1M5.2 9 3.7 10.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                  />
                </svg>
              }
            </span>

            @if (row.blurb) {
              <span class="row__blurb">{{ row.blurb }}</span>
            }

            @if (
              row.feature.disclaimer &&
              row.feature.disclaimer.visibleOnLevels?.includes(activeLevel!)
            ) {
              <span class="row__note">{{ row.feature.disclaimer.text }}</span>
            }
          </span>

          @if (row.feature.tooltip) {
            <app-feature-tooltip
              class="row__info"
              [isFeatureInaccessibleType]="!isAccessible"
              [featureConst]="row.feature.featureConst"
              [featureName]="row.feature.tooltip.headerText"
              [headerText]="row.feature.tooltip.headerText"
              [tooltipText]="row.feature.tooltip.text"
              (openTooltipModal)="openTooltipModal.emit($event)"
            ></app-feature-tooltip>
          }
        </div>

        @if (isActive) {
          <app-colorscale
            class="row__scale"
            [colors]="colorScaleService.colorScaleColors"
          ></app-colorscale>
        }
      </div>
    }
  }
</div>
